var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.91797C3.79086 2.91797 2 4.70883 2 6.91797V18.918C2 21.1271 3.79086 22.918 6 22.918H18C20.2091 22.918 22 21.1271 22 18.918V6.91797C22 4.70883 20.2091 2.91797 18 2.91797H6ZM11.7776 7.91797L14.5141 18.4735H12.3332L11.7859 16.3624H8.72823L8.18091 18.4735H6L8.73661 7.91797H11.7776ZM9.27555 14.2513H11.2386L10.2571 10.4653L9.27555 14.2513ZM17.646 7.91797V18.4735H15.5349V7.91797H17.646Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap21);
export default __webpack_public_path__ + "static/media/map21.b74a31975c3c14a29d11b267d4336d50.svg";
export { ForwardRef as ReactComponent };